import React from "react";
import BaseButton from "@reusables/BaseButton";
import { toast } from "react-toastify";
import BaseModal from "@reusables/Modals/BaseModal";
import { useTranslation } from "react-i18next";
import { PaymentTerms } from "@/types/general";
import { useDeletePaymentTermsMutation } from "@redux/features/paymentTerms/paymentTermsApi";

interface DeletionModalProperties {
    isOpen: boolean;
    paymentTerms?: PaymentTerms.Root;
    onClose: () => void;
}

export default function DeletionModal(props: DeletionModalProperties){
    const { t } = useTranslation("", { keyPrefix: "settings.general.paymentTerms.modals.deletion" });

    const [deletePaymentTerms, { isLoading: isDeletionLoading }] = useDeletePaymentTermsMutation();

    return (
      <BaseModal
        isOpen={props.isOpen}
        onClose={props.onClose}
        width={700}
        padding="56px"
        isLoading={isDeletionLoading}
      >
          <div className="space-y-[32px]">
              <div className="text-xl font-semibold text-center text-accent">{t("heading")}</div>
              <div className="text-center text-accent">{t("subheading")}.</div>
              <div className="grid grid-cols-2 gap-[16px]">
                  <BaseButton text={t("buttons.cancel")} size="md" primaryOutlined onClick={props.onClose} />
                  <BaseButton text={t("buttons.delete")} size="md" onClick={() => {
                      if(props.paymentTerms) {
                          deletePaymentTerms(props.paymentTerms.id).unwrap().then(resp => {
                              toast.success(t("responses.success"));
                          }).catch(e => {
                              console.error(e);

                              toast.error(t("responses.error"));
                          })
                          .finally(() => props.onClose());
                      }
                  }}/>
              </div>
          </div>
      </BaseModal>
    )
}